import AdminFaxDetails from './admin-fax-details-component';
import AdminFaxDetailsService from './admin-fax-details-service';

import './admin-fax-details.scss';

const MODULE_NAME = 'App.admin.fax.details';
const module = angular.module(MODULE_NAME, [])
    .directive(AdminFaxDetails.DIRECTIVE_NAME, AdminFaxDetails)
    .service('adminFaxDetailsService', AdminFaxDetailsService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/admin-fax-details/admin-fax-details-module.js